import { shiftEditorViewState } from "..";
import { mutatorAction } from "satcheljs";

export default mutatorAction("setShareDisabled", function setShareDisabled(share: boolean) {
    shiftEditorViewState().disableShare = share;
});